<wl-experience-editor>
  <ng-template wlPreview>
    <span> <strong>Bewerk deze video:</strong> </span>
    @if (video$ | async; as video) {
      <img [src]="video?.imageUrl" class="img-fluid mx-auto d-block" />
    }
  </ng-template>

  <ng-template wlLive>
    <!-- Wait for video url to load, otherwise video source is set to null -->

    @if (video$ | async; as video) {
      @if (videoAllowed) {
        <wl-video
          [video]="video"
          trackImpression="contentblock-impression"
          [trackImpressionInfo]="rendering"
          [trackImpressionContext]="context"
        ></wl-video>
      } @else {
        <wl-video-fallback
          [aspectRatio]="video.aspectRatio!"
          [imageUrl]="video?.imageUrl"
        >
        </wl-video-fallback>
      }
    }
  </ng-template>
</wl-experience-editor>
